import SchoolsAdapter from './base';

export default class UsageSet extends SchoolsAdapter {
  modelNamePlural = 'usageSets';
}
